import React from 'react';
import { Route } from 'react-router-dom';
import ReviewerLogin from '../modules/reviewer/ReviewerLogin';
import ReviewerRegister from '../modules/reviewer/ReviewerRegister';
import ReviewerDashboard from '../modules/reviewer/ReviewerDashboard';
import ReviewerReview from '../modules/reviewer/ReviewerReview';
import ReviewerLayout from '../modules/reviewer/ReviewerLayout';
import ReviewSubmissions from '../modules/reviewer/ReviewSubmissions';
import ReviewerViewComments from '../modules/reviewer/ReviewerViewComment';
import ReviewerAllPaper from '../modules/reviewer/ReviewerAllPaper';
import ProtectedRoute from './ProtectedRoute';

const ReviewerRoutes = (
  <>
    <Route path="/login" element={<ReviewerLogin />} />
    <Route path="/register" element={<ReviewerRegister />} />
    {/* <Route path="/dashboard" element={<ReviewerDashboard />} /> */}
    <Route path="/review/:submissionID" element={<ReviewerReview />} />

    <Route element={<ProtectedRoute requiredRole="reviewer" />}>
      <Route path="/reviewer" element={<ReviewerLayout />}>
        <Route path="dashboard" element={<ReviewerDashboard />} />
        <Route path="review-submissions" element={<ReviewSubmissions />} />
        <Route path="review-comments" element={<ReviewerViewComments />} />
        <Route path="review-all-papers" element={<ReviewerAllPaper />} />
      </Route>
      <Route path="review/:submissionID" element={<ReviewerReview />} />
    </Route>
  </>
);

export default ReviewerRoutes;
